import loadable from '@loadable/component';

export const LazyRegistrationGuest = loadable(() => import(/* webpackChunkName: "content/registration/guest" */ '.'));
